import { Task } from "twilio-taskrouter";
import { CompleteTask } from "../CompleteTask/CompleteTask";
import { ErrorCode, ErrorSeverity, FlexSdkError } from "~/modules/error";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { CbmImpl } from "~/modules/cbm";
import { ContextManager } from "~/modules/contextManager/ContextManager";
import { getReservationsByTask, isCallTask, sendTrackingEvent } from "../../ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";
import { Action } from "~/modules/actions/Action";
import { WrapUpTask } from "../WrapUpTask/WrapUpTask";



















export class EndTask implements Action<Promise<Task>> {
    


    #taskSid: string;

    constructor(taskSid: string) {
        this.#taskSid = taskSid;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const taskRouter = context.getInstanceOf(TaskRouterImpl);
        const logger = getLogger(context)(LoggerName.Actions);
        const worker = taskRouter.worker;
        const analytics = context.getInstanceOf(AnalyticsImpl);
        const cbm = context.getInstanceOf(CbmImpl);

        logger.debug(`endTask invoked with taskSid: ${this.#taskSid}`);

        if (!worker) {
            const errorMsg = "endTask: worker is not initialized";
            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        if (!cbm) {
            const errorMsg = "endTask: CBM SDK is not initialized";
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.EndTaskCompleted, analytics, worker, errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        const reservations = getReservationsByTask(worker, this.#taskSid);
        const reservation = reservations.find((res) => res.status === "accepted");
        const wrappingReservation = reservations.find((res) => res.status === "wrapping");

        if (!reservation && !wrappingReservation) {
            const errorMsg = `endTask: Reservation for task ${this.#taskSid} is not found`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.EndTaskCompleted, analytics, worker, errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        try {
            if (reservation && isCallTask(reservation.task)) {
                return (await cbm.endConference(reservation)).task;
            }
            if (wrappingReservation) {
                return Promise.resolve(await new CompleteTask(this.#taskSid).run(ctx));
            }
            const { task } = await new WrapUpTask(this.#taskSid).run(ctx);

            sendTrackingEvent(EVENTS.EndTaskCompleted, analytics, worker);

            return Promise.resolve(task);
        } catch (error) {
            const errorMsg = `endTask: Could not end task: ${error.message}`;
            sendTrackingEvent(EVENTS.EndTaskCompleted, analytics, worker, errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }
    }
}
